import React from "react";
import UnifiedSearchMockupPage from "../../features/unifiedSearchMockup/UnifiedSearchMockupPage";

/** Phase 0 UI mockup only — no API / production wiring. */
export default function UnifiedSearchMockupStandalonePage() {
  return <UnifiedSearchMockupPage />;
}
